"use strict";

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
(function ($) {
  // ECMA5 strict mode
  'use strict';

  // check namespace
  $.b2b = $.b2b || {};

  //общие константы
  $.b2b.CONSTS = {
    EMPTY_GUID: '00000000-0000-0000-0000-000000000000',
    CHAT_API_TOKENDATA_KEY: 'CHAT_API_TOKENDATA_KEY_V2',
    CHAT_API_CHATSTATE_KEY_PREFIX: 'CHAT_API_CHATSTATE_V2_',
    USER_SELECTED_THEME_KEY: 'USER_SELECTED_THEME_KEY'
  };

  /** Настройки UI B2B */
  $.b2b.uiSettings = {
    /** Время ожидания ответа от LE1 */
    LE1Timeout: 6
  };

  //общие строковые ресурсы
  var I18N = $.b2b.I18N = {
    CONFIRMATION_TITLE: 'Подтверждение',
    NOTIFICATION_TITLE: 'Уведомление',
    AJAX: {
      AJAX_ERROR: 'Ошибка получения данных.',
      ERROR_UNKNOWN: 'Неизвестная ошибка'
    }
  };
  (function init() {
    showEmailConfirmationStatusNotification();
    checkUserPassword();
  })();
  var template = '<div class="modal fade" id="b2bMessageContainer" tabindex="-1" role="dialog" aria-labelledby="b2bMessageContainer" aria-hidden="true">' + '<div class="modal-dialog">' + '<div class="modal-content">' + '<div class="modal-header">' + '<button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span class="sr-only">Закрыть</span></button>' + '<h4 class="modal-title bold" id="b2bMessageContainerLabel">#title#</h4>' + '</div>' + '<div class="modal-body">#body#</div>' + '<div class="modal-footer">#btns#</div>' + '</div>' + '</div>' + '</div>';
  // диалоговые окна b2b
  $.b2b.msg = {
    alert: function alert(title, message, onClose, width, height, onShow, modalClass) {
      /// <summary>Кастомный алерт.</summary>
      var tmpl = template.replace('#title#', title || I18N.NOTIFICATION_TITLE).replace('#body#', message || '').replace('#btns#', '<button type="button" class="btn btn-sm btn-default" data-dismiss="modal">OK</button>');
      var $modal = $(tmpl);
      if (modalClass) {
        $modal.addClass(modalClass);
      }
      if (width) {
        $modal.find('.modal-dialog').css({
          width: width,
          maxWidth: '95vw'
        });
      }
      $modal.modal({
        backdrop: 'static',
        keyboard: true,
        show: true
      }).on('hidden.bs.modal', function (e) {
        if (typeof onClose === 'function') {
          onClose.apply(null, []);
        }
      }).on('shown.bs.modal', function () {
        if (typeof onShow === 'function') {
          onShow.apply(null, []);
        }
      });
    },
    confirm: function confirm(message, confirmBtnText, title, onConfirm, onCancel, width, height) {
      /// <summary>Диалог подтверждения действия пользователя</summary>
      var tmpl = template.replace('#title#', title || I18N.CONFIRMATION_TITLE).replace('#body#', message || '').replace('#btns#', '<button type="button" class="btn btn-sm btn-default" data-dismiss="modal">Отмена</button><button type="button" class="btn btn-sm btn-primary">' + (confirmBtnText || 'Подтверждаю') + '</button>');
      var m = $(tmpl).modal({
        backdrop: 'static',
        keyboard: false,
        show: true
      });
      m.on('hidden.bs.modal', function (e) {
        if (typeof onCancel === 'function') onCancel();
      }).find('.btn-primary').click(function () {
        m.modal('hide');
        if (typeof onConfirm === 'function') onConfirm();
      });
    }
  };
  $.b2b.errors = {
    getJsonError: function getJsonError(jqXHR) {
      /// <summary>Проверка объекта XHR на ошибку в формате JSON.</summary>
      /// <param name="jqXHR" type="Object"></param>
      if (jqXHR && jqXHR.getResponseHeader("X-Json-Response") == 1) {
        return $.parseJSON(jqXHR.response || jqXHR.responseText);
      }
      return null;
    },
    showAjaxError: function showAjaxError(data, options) {
      /// <summary>Функция для обработки ошибки AJAX.</summary>
      /// <param name="message" type="Object"></param>

      var text;
      if (typeof data.getResponseHeader === 'function') {
        // передали XHR-объект
        var xhr = data;
        data = $.b2b.errors.getJsonError(xhr); // может быть JSON, а может быть html/text

        if (data && data.Success) {
          text = data.Errors[0]; // json
        } else {
          text = $.b2b.I18N.AJAX.AJAX_ERROR + ' Детали: ' + xhr.statusText;
        }
        $.b2b.toastNotificationService.showError(text, {
          timeout: 0
        });
        return;
      }

      // передали данные и опции (angular)
      if (options != undefined && options.headers) {
        if (options.headers("x-json-response") === "1") {
          text = data.Errors[0]; // точно json
        } else {
          text = options.unknownText || I18N.AJAX.AJAX_ERROR;
        }
      } else {
        text = data;
      }
      $.b2b.toastNotificationService.showError(text, {
        timeout: 0
      });
      if (options != undefined && typeof options.callback === 'function') {
        options.callback.call(window); // reload data or smth
      }
    }
  };
  $.b2b.ajax = function (params) {
    /// <summary>Метод для выполнения ajax, содержащий общую обработку ошибок.</summary>
    ///<param name="params" type="Object">Объект с параметрами для ajax-запроса. 
    ///<para>params.url - урл запроса. </para>
    ///<para>params.type  - http-метод, если не задан то GET. </para>
    ///<para>params.dataType - тип данных ответа. Если не задан, то JSON. Только JSON гарантирует, что при ошибке на сервере ошибка вернется на клиент.</para>
    ///<para>params.data - данные для урла.</para>
    ///<para>params.cache - кэширование запроса. Если не задан, то false</para>
    ///<para>params.contentType - тип данных. Если не задан, то application/x-www-form-urlencoded; charset=UTF-8</para>
    ///<para>params.success - обработчик завершения ajax-запроса, будет вызыван, если результат запроса Success, иначе будет показана ошибка. Т.е. свою обработку ошибок делать не надо. 
    ///Предпочтительный метод обработки завершения запроса.</para>		
    ///<para>params.internalSuccess - обработчик завершения ajax-запроса. Никакая обработка ошибок до вызова этого метода не будет использоваться, о ней нужно позаботиться саомому. </para>
    ///<para>params.internalError - обработчик ошибки ajax-запроса. Следует задавать, только если сами хотите обрабатывать ошибки. Предпочтительнее не задавать.</para></param>

    var CONSTS = {
      DEFAULT_TYPE: "GET",
      DEFAULT_DATA_TYPE: "json",
      DEFAULT_CONTENT_TYPE: "application/x-www-form-urlencoded; charset=UTF-8"
    };
    return $.ajax({
      url: params.url,
      type: params.type !== undefined ? params.type : CONSTS.DEFAULT_TYPE,
      dataType: params.dataType !== undefined ? params.dataType : CONSTS.DEFAULT_DATA_TYPE,
      data: params.data,
      cache: params.cache !== undefined ? params.cache : false,
      processData: params.processData,
      contentType: params.contentType !== undefined ? params.contentType : CONSTS.DEFAULT_CONTENT_TYPE,
      success: params.internalSuccess || function (result) {
        if (result.Success) {
          if (params.success) {
            params.success(result.Data);
          }
        } else {
          var error = result.Errors && result.Errors.length > 0 ? result.Errors[0] : $.b2b.I18N.AJAX.ERROR_UNKNOWN;
          if (params.unsuccess) {
            params.unsuccess(error);
          }
          $.b2b.toastNotificationService.showError(error, {
            timeout: 0
          });
        }
      },
      error: params.internalError || $.b2b.errors.showAjaxError
    });
  };
  $.b2b.isSet = function (value) {
    return value !== null && typeof value !== 'undefined';
  };
  // Проверка на null при вызове вложенных объектов
  // Пример вызова: $.b2b.get(obj, "prop1.prop2")
  $.b2b.get = function (obj, key) {
    return key.split(".").reduce(function (o, x) {
      return typeof o === "undefined" || o === null ? o : o[x];
    }, obj);
  };

  //Проверка на пустое значение
  $.b2b.isEmpty = function (value) {
    return typeof value === "undefined" || value === null || value === "";
  };
  $.b2b.getChatApiTokenData = function (clearOldToken) {
    var d = $.Deferred();
    var tokenData = null;
    if (clearOldToken === true) {
      localStorage.removeItem($.b2b.CONSTS.CHAT_API_TOKENDATA_KEY);
    } else {
      tokenData = localStorage.getItem($.b2b.CONSTS.CHAT_API_TOKENDATA_KEY);
    }
    var needToUpdateToken = tokenData === null;
    if (tokenData !== null) {
      var tokenInfo = JSON.parse(atob(tokenData.split('.')[1]));
      needToUpdateToken = tokenInfo.exp * 1000 < new Date().getTime();
    }
    if (needToUpdateToken) {
      $.ajax({
        url: "/ChatApi/getChatApiTokenData",
        type: "GET",
        dataType: "json",
        success: function success(data) {
          localStorage.setItem($.b2b.CONSTS.CHAT_API_TOKENDATA_KEY, JSON.stringify(data.Data));
          d.resolve(data.Data);
        },
        error: function error(jqXHR) {
          d.reject(jqXHR);
        }
      });
    } else {
      d.resolve(JSON.parse(tokenData));
    }
    return d.promise();
  };

  /// <summary>Метод для выполнения ajax запроса к chatAPI, содержащий логику исполользования токена доступа.
  /// При запросе используется текущий токен доступа (если он есть). В случае ошибки с кодом 401, или если токена доступа нет, токен будет запрошен
  /// с сервера, затем будет выполнен повторный запрос.</summary >
  ///<param name="options" type="Object">Объект с параметрами для ajax-запроса.
  ///<para>options.url - урл запроса. </para>
  ///<para>options.type  - http-метод, если не задан то GET. </para>
  ///<para>options.dataType - тип данных ответа. Если не задан, то JSON.</para>
  ///<para>options.data - данные для урла.</para>
  ///<para>options.cache - кэширование запроса. Если не задан, то false</para>
  ///<para>options.contentType - тип данных. Если не задан, то application/x-www-form-urlencoded; charset=UTF-8</para>
  ///<returns>promise-объект
  $.b2b.chatApiRequest = function (options) {
    var CONSTS = {
      DEFAULT_TYPE: "GET",
      DEFAULT_DATA_TYPE: "json",
      DEFAULT_CONTENT_TYPE: "application/x-www-form-urlencoded; charset=UTF-8"
    };
    var makeCall = function makeCall(params, token, baseUrl) {
      var makeCallResult = $.Deferred();
      var url = baseUrl + params.url;
      $.ajax({
        url: url,
        type: params.type || CONSTS.DEFAULT_TYPE,
        dataType: params.dataType || CONSTS.DEFAULT_DATA_TYPE,
        data: params.data,
        //crossDomain: true,
        cache: params.cache || false,
        contentType: params.contentType || CONSTS.DEFAULT_CONTENT_TYPE,
        beforeSend: function beforeSend(xhr) {
          xhr.setRequestHeader("Authorization", "Bearer " + token);
        },
        success: function success(result) {
          makeCallResult.resolve(result);
        },
        error: function error(_error) {
          makeCallResult.reject(_error);
        }
      });
      return makeCallResult.promise();
    };
    var chatApiRequest = $.Deferred();
    $.b2b.getChatApiTokenData().then(function (tokenData) {
      return makeCall(options, tokenData.token, tokenData.url).then(function (data) {
        //всё гут, отдаём результат
        chatApiRequest.resolve(data);
      })["catch"](function (err) {
        if (err !== undefined && err.status === 401) {
          //если код 401, значит с токеном что-то не то (протух, как вариант) - то запросим новый токен с очисткой старого
          return $.b2b.getChatApiTokenData(true).then(function (tokenData) {
            return makeCall(options, tokenData.token, tokenData.url).then(function (data) {
              //всё гут, отдаём результат
              chatApiRequest.resolve(data);
            });
          });
        } else {
          throw err;
        }
      });
    })["catch"](function (err) {
      //на каком-то этапе произошло непоправимое, делегируем проблемы вышестоящим слушателям
      chatApiRequest.reject(err);
    });
    return chatApiRequest.promise();
  };

  //Проверить, что значение id пользователя в данных токена для chatAPI совпадает с переданным userId. Если не совпадает, либо если нет данных токена, вернёт false, иначе true.
  $.b2b.checkTokenAccessory = function (userId) {
    if (userId === null) return false;
    var tokenData = localStorage.getItem($.b2b.CONSTS.CHAT_API_TOKENDATA_KEY);
    if (tokenData !== null) {
      return JSON.parse(tokenData).id === userId;
    }
    return false;
  };
  $.b2b.saveChatWidgetState = function (state) {
    var tokenData = localStorage.getItem($.b2b.CONSTS.CHAT_API_TOKENDATA_KEY);
    if (tokenData !== null) {
      var userId = JSON.parse(tokenData).id;
      localStorage.setItem($.b2b.CONSTS.CHAT_API_CHATSTATE_KEY_PREFIX + userId, JSON.stringify(state));
    }
  };
  $.b2b.loadChatWidgetState = function () {
    var tokenData = localStorage.getItem($.b2b.CONSTS.CHAT_API_TOKENDATA_KEY);
    if (tokenData !== null) {
      var userId = JSON.parse(tokenData).id;
      var data = localStorage.getItem($.b2b.CONSTS.CHAT_API_CHATSTATE_KEY_PREFIX + userId);
      if (data !== null) return JSON.parse(data);
    }
    return null;
  };

  /* keep bootstrap dropdown open when clicked */
  $('.dropdown.keep-open .dropdown-menu').on('click', function (e) {
    e.stopPropagation();
  });
  $.b2b.clearChatApiTokenData = function () {
    localStorage.removeItem($.b2b.CONSTS.CHAT_API_TOKENDATA_KEY);

    //Новый виджет
    var widget = document.getElementById('chatWidget');
    widget && widget.signOut && widget.signOut();
  };
  $.b2b.getChatApiProxiedUrl = function (relativePathUrl) {
    var apiServiceUrl = '/chatproxy';
    return apiServiceUrl + relativePathUrl;
  };
  $.b2b.ChatApiError = function (message, code) {
    this.name = 'ChatApiError';
    this.message = message || 'Ошибка работы с ChatAPI';
    this.code = code;
    this.stack = new Error().stack;
  };
  $.b2b.ChatApiError.prototype = Object.create(Error.prototype);
  $.b2b.ChatApiError.prototype.constructor = $.b2b.ChatApiError;
  $.b2b.ChatApiHub = function () {
    var instance = null;
    var startPromise = null;
    var instanceCreatePromise = $.Deferred();
    var token = null;
    var needUpdateToken = false;
    // очередь отправки SignalR сообщений.
    // будут попытки отправки пока не предет подтверждение от сервера
    var messageQueue = [];
    var messageQueueTimer = null;
    var isDisconnected = function isDisconnected() {
      return !instance || instance.state === 'Disconnected';
    };
    var getToken = function getToken() {
      var getTokenResult = $.Deferred();
      if (token === null || needUpdateToken) {
        $.b2b.getChatApiTokenData(needUpdateToken).then(function (tokenData) {
          needUpdateToken = false;
          token = tokenData.token;
          getTokenResult.resolve(token);
        }, function (err) {
          getTokenResult.reject(err);
        });
      } else {
        getTokenResult.resolve(token);
      }
      return getTokenResult.promise();
    };
    var sendAllMessagesFromQueue = function sendAllMessagesFromQueue() {
      if (!messageQueue || messageQueue.length === 0) return;
      var _iterator = _createForOfIteratorHelper(messageQueue),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var msg = _step.value;
          instance.send(msg.messageType, msg.message);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    };
    var addMessageToQueue = function addMessageToQueue(messageType, message) {
      messageQueue.push({
        messageType: messageType,
        message: message
      });
      instance.send(messageType, message);
    };
    var startMessageQueueTimer = function startMessageQueueTimer() {
      messageQueueTimer = setInterval(sendAllMessagesFromQueue, 5000);
    };
    var stopMessageQueueTimer = function stopMessageQueueTimer() {
      clearInterval(messageQueueTimer);
    };
    var createHubInstance = function createHubInstance(hubUrl) {
      return new signalR.HubConnectionBuilder().withUrl(hubUrl, {
        accessTokenFactory: getToken,
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets
      }).withAutomaticReconnect().configureLogging(signalR.LogLevel.Trace).build();
    };
    var createHubClient = function createHubClient() {
      //сам объект-хаб скрыт, выдаём прокси
      return {
        on: function on(eventName, callback) {
          instance.on(eventName, callback);
        },
        off: function off(eventName, callback) {
          instance.off(eventName, callback);
        },
        removeMessageFromQueue: function removeMessageFromQueue(messageId) {
          messageQueue = messageQueue.filter(function (m) {
            return m.message.Id !== messageId;
          });
        },
        addChatMessage: function addChatMessage(text, chatId) {
          var addMessageObject = {
            Text: text,
            IsInternal: false,
            MessageSource: 4,
            ChatId: chatId,
            EventId: 0,
            MentionedPersonIds: [],
            Id: crypto.randomUUID()
          };
          addMessageToQueue("AddMessage", addMessageObject);
        },
        onclose: function onclose(callback) {
          instance.onclose(function (error) {
            console.log('Соединение с сервером чата прекращено.');
            callback(error);
          });
        },
        onreconnecting: function onreconnecting(callback) {
          instance.onreconnecting(callback);
        },
        start: function start() {
          if (!isDisconnected()) {
            console.trace('Соединение с SignalR уже установлено');
            return;
          }
          return startPromise || (startPromise = instance.start()
          // без done() иногда не отрабатывает start()
          .done(function () {
            startMessageQueueTimer();
          })["catch"](function () {
            console.warn("error in ChatHub.StartPromise");
            //возможно, токен тухлый - перезапросим и перестартанём разок
            return instance.start()["catch"](function (err) {
              //сообщаем пренеприятнейшее известие в лог и в глаз и двигаем дальше
              //$.b2b.errors.showAjaxError('Соединение с сервером чата не установлено.');
              console.error('Соединение с сервером чата не установлено.');
              throw err;
            });
          }));
        },
        stop: function stop() {
          stopMessageQueueTimer();
          return instance.stop().then(function () {
            return console.log('Соединение с SignalR остановлено');
          });
        }
      };
    };
    return {
      getInstance: function getInstance() {
        if (instance) instanceCreatePromise.resolve(instance);else {
          $.b2b.getChatApiTokenData().then(function (tokenData) {
            var hubUrl = tokenData.url + '/Signal';
            token = tokenData.token;
            try {
              var result = instance || (instance = createHubInstance(hubUrl));
              instanceCreatePromise.resolve(createHubClient(result));
            } catch (err) {
              instanceCreatePromise.reject(err);
            }
          });
        }
        return instanceCreatePromise.promise();
      }
    };
  }();
  //активна ли вкладка браузера
  $.b2b.documentIsActive = function () {
    return !document.hidden;
  };
  $.b2b.ChatMessageStatus = {
    Created: 1,
    CreationError: 2
  };
  function checkUserPassword() {
    $.get("/Account/CheckUserPassword").done(function (data) {
      if (data.UserUnauthorized) return;
      if (data.PasswordOutdated) {
        window.location.href = "/Account/Login".concat(new URL(window.location.href).search);
      }
      if (data.EmailConfirmedSuccess) {
        $.b2b.toastNotificationService.showSuccess('Электронная почта подтверждена');
      }
      if (data.PasswordOutdateSoon) {
        var passwordWarnKey = 'passwordObsoleteWarnLastDate';
        var today = new Date().setHours(0, 0, 0, 0);
        var lastWarnRaw = localStorage.getItem(passwordWarnKey);
        var lastWarn = lastWarnRaw ? new Date(lastWarnRaw).setHours(0, 0, 0, 0) : null;
        if (lastWarn === today) {
          // Предупреждение о сроке пароля — не чаще одного раза в день
        } else {
          localStorage.setItem(passwordWarnKey, new Date().toISOString());
          var outdateString = '';
          if (data.DaysUntilObsolete === 0) {
            outdateString = 'Ваш пароль сегодня устареет';
          } else {
            var daysWord = data.DaysUntilObsolete === 1 ? 'день' : data.DaysUntilObsolete > 0 && data.DaysUntilObsolete <= 4 ? 'дня' : 'дней';
            outdateString = "\u0412\u0430\u0448 \u043F\u0430\u0440\u043E\u043B\u044C \u0431\u0443\u0434\u0435\u0442 \u043F\u0440\u043E\u0441\u0440\u043E\u0447\u0435\u043D \u0447\u0435\u0440\u0435\u0437 ".concat(data.DaysUntilObsolete, " ").concat(daysWord);
          }
          $.b2b.toastNotificationService.showWarning("\u0412\u043D\u0438\u043C\u0430\u043D\u0438\u0435!\n                    ".concat(outdateString, ", \u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430 <a href=\"/Account/PasswordReset\">\u0438\u0437\u043C\u0435\u043D\u0438\u0442\u0435 \u043F\u0430\u0440\u043E\u043B\u044C</a> \u0432 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430\u0445 \u043F\u0440\u043E\u0444\u0438\u043B\u044F."), {
            timeout: 10000
          });
        }
      }
      if (data.NeedEmailConfirmation) {
        var emailConfirmationWarnKey = 'emailConfirmationWarnLastDate';
        var _today = moment().startOf('day');
        var _lastWarnRaw = localStorage.getItem(emailConfirmationWarnKey);
        var _lastWarn = _lastWarnRaw ? moment(_lastWarnRaw).startOf('day') : null;
        if (!_lastWarn || !_lastWarn.isSame(_today)) {
          localStorage.setItem(emailConfirmationWarnKey, moment().toISOString());
          showEmailConfirmationModal();
        }
      }
    });
  }
  function showEmailConfirmationModal() {
    var message = 'Просьба подтвердить электронную почту, которая привязана к вашей учетной записи. Если у вас возникли трудности или вы не получили письмо с подтверждением, просьба написать на почту b2b-info@treolan.ru. Не забудьте проверить папку "Спам"';
    var title = 'Подтверждение электронной почты';
    var backdropZIndex = 2000000;
    var tmpl = '<div class="modal fade" id="b2bEmailConfirmContainer" tabindex="-1" role="dialog" aria-labelledby="b2bEmailConfirmLabel" aria-hidden="true">' + '<div class="modal-dialog">' + '<div class="modal-content">' + '<div class="modal-header">' + '<h4 class="modal-title bold" id="b2bEmailConfirmLabel">' + (title || I18N.NOTIFICATION_TITLE) + '</h4>' + '</div>' + '<div class="modal-body">' + (message || '') + '</div>' + '<div class="modal-footer">' + '<button type="button" class="btn btn-sm btn-primary">Подтвердить</button>' + '</div>' + '</div></div></div>';
    var m = $(tmpl).modal({
      backdrop: 'static',
      keyboard: false,
      show: true
    });
    m.on('shown.bs.modal', function () {
      // Поднимаем окно и подложку выше меню с кастомными z-index.
      m.css('z-index', backdropZIndex + 1);
      $('.modal-backdrop').last().css('z-index', backdropZIndex);
    });
    m.find('.btn-primary').click(function () {
      m.modal('hide');
      $.b2b.ajax({
        url: '/EmailConfirmation/SendConfirmation',
        type: 'POST',
        success: function success() {
          $.b2b.toastNotificationService.showInfo('На вашу электронную почту отправлено уведомление. Просьба проверить');
        }
      });
    });
  }
  function showEmailConfirmationStatusNotification() {
    var currentUrl = new URL(window.location.href);
    var searchParams = currentUrl.searchParams;
    var emailConfirmError = searchParams.get('emailConfirmError');
    if (emailConfirmError) {
      $.b2b.toastNotificationService.showError(emailConfirmError, {
        timeout: 0
      });
      searchParams["delete"]('emailConfirmError');
      window.history.replaceState({}, document.title, "".concat(currentUrl.pathname).concat(searchParams.toString() ? "?".concat(searchParams.toString()) : '').concat(currentUrl.hash));
    }
  }

  /** Экранирование символов < и > в пароле для прохождения Request Validation (защита от XSS) */
  $.b2b.escapePasswordForRequest = function (value) {
    if (typeof value !== 'string') return value;
    return value.replace(/</g, "\\u003c").replace(/>/g, "\\u003e");
  };
})(jQuery);
function groupBy(data, key) {
  return data.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
}
Array.prototype.groupBy = function (groupingKeyFn) {
  if (typeof groupingKeyFn !== 'function') {
    throw new Error("groupBy take a function as only parameter");
  }
  return this.reduce(function (result, item) {
    var key = groupingKeyFn(item);
    if (!result[key]) result[key] = [];
    result[key].push(item);
    return result;
  }, {});
};
function showRequestSpecsStatuses(specsStatuses) {
  var groupedStatuses = specsStatuses.filter(function (o) {
    return o.Message;
  }).groupBy(function (key) {
    return key.Message;
  });
  Object.keys(groupedStatuses).forEach(function (group) {
    if (!group) return;
    var div = $('<div/>');
    div.append("<span>".concat(group, "</span>"));
    div.append('<ul style="margin: 0;padding-left: 15px;"/>');
    groupedStatuses[group].map(function (o) {
      return div.find('ul').append("<li><b>".concat(o.Articul, "</b></li>"));
    });
    $.b2b.toastNotificationService.showError(div.html());
  });
}
function importPositions(containerId, event) {
  Ya && Ya.reachGoal(event);
  var rows = $(containerId).find('#positions').val().split('\n');
  for (var i = 0; i < rows.length; i++) {
    rows[i] = rows[i].trim();
  }
  if (!rows || !rows.length) return;
  var divider = String.fromCharCode($(containerId).find('#divider').val());
  var items = [];
  var errorMessage = '';
  var _iterator2 = _createForOfIteratorHelper(rows),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var row = _step2.value;
      if (!row || !row.length) continue; //Пропускаем пустые строки

      var data = row.split(divider);
      if (!data[1]) {
        errorMessage += "\u041D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u043E \u0432\u044B\u0431\u0440\u0430\u043D \u0440\u0430\u0437\u0434\u0435\u043B\u0438\u0442\u0435\u043B\u044C \u0434\u043B\u044F \u0441\u0442\u0440\u043E\u043A\u0438 \"".concat(row, "\"<br />");
      }
      items.push({
        Articul: data[0].trim(),
        Qty: data[1].trim()
      });
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  if (errorMessage) {
    $.b2b.toastNotificationService.showError(errorMessage);
    return;
  }
  $.b2b.ajax({
    url: '/Cart/ImportPositions',
    type: 'POST',
    data: {
      items: items,
      noHPOptions: false,
      returnCart: false
    },
    dataType: 'JSON'
  }).done(function (result) {
    return location.href = '/Cart';
  });
}